import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    areaList:[],
  },
  mutations: {
    setAreaList (state, area) {
      state.areaList = area
    },
  },
  getters: {
    getAreaList: state => {
      return state.areaList
    },
  }
})
